// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {FormHelperText, Input, InputLabel, Select, Stack, TextField, Tooltip} from "@mui/material";

// App Imports
import {
    addContractDataPointValueFilter,
    editContractDataPointValueFilter,
    getCDPVFbyCDPid, updateCdpvfHierarchy, updateCdpvfMockValueAdd, updateCdpvfMockValueEdit
} from "./ContractDataPointValueFilterClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPoints} from "../DataPoint/DataPointClient";
import {changeContractDataPoint} from "../ContractDataPoint/contractDataPointSlice";
import {changeContractDrilldownCDPVF} from "../ContractDrilldown/ContractDrilldownCDPVF/contractDrilldownSliceCDPVF";
import {Autocomplete} from "@mui/lab";
import DynamicCdpvValueField from "../CommonComponents/DynamicCdpvValueField";
import dayjs from "dayjs";
import CdpvfInfoDialogue from "./Info/CdpvfInfoDialogue";



// Main Function
export default function ContractDataPointValueFilterDrawer() {


    // ****************** BEGIN STATES ****************************

    const [showContractDataPointValueFilterDrawer, setShowContractDataPointValueFilterDrawer] = React.useState(false);
    const [submitting, setSubmitting] = useState(true);
    const [cdpvfInfoOpen, setCdpvfInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchData = useDispatch() ;
    // const selectorContractDataPointValueFilterId = useSelector((state) => state.contractDataPointValueFilterSlc.value.id);
    // const contractDataPointValueFilterDrawerMode = useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfDrawerMode);
    const selectorContractDataPointValueFilterId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.id);
    const contractDataPointValueFilterDrawerMode = useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfDrawerMode);

    const selectorCdpId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.contractDataPointId);
    const selectorSingleValue = useSelector((state) => state.contractDrilldownSlcCDPVF.value.singleValue);
    const selectorFromValue = useSelector((state) => state.contractDrilldownSlcCDPVF.value.fromValue);
    const selectorToValue = useSelector((state) => state.contractDrilldownSlcCDPVF.value.toValue);
    const [selectedDataType, setSelectedDataType] = useState([useSelector((state) => state.contractDrilldownSlcCDPVF.value.dataType)]);
    const selectorDPVid = useSelector((state) => state.contractDrilldownSlcCDPVF.value.singleValueNumber);
    const [showPreviousMenu, setShowPreviousMenu] = React.useState(true);
    const selectorDPid = useSelector((state) => state.contractDrilldownSlcCDPVF.value.dataPointId);
    const selectorDataPointId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.dataPointId);
    const selectorDataType = useSelector((state) => state.contractDrilldownSlcCDPVF.value.dataType);

    const selectedCdpDp = useSelector((state) => state.contractSectionSlc.value.dataPointId);
    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************


    // const {register, handleSubmit} = useForm();
    const { register, handleSubmit,setValue,  control, formState: { errors } } = useForm();
    // ****************** END REGISTER ****************************

    useEffect(() => {
        let formattedSingleValue = selectorSingleValue;

        if (selectorDataType === 'DATE') {
            if (selectorSingleValue && selectorSingleValue.format) {
                formattedSingleValue = dayjs(selectorSingleValue).format('MM/DD/YYYY');
            } else if (selectorSingleValue instanceof Date) {
                formattedSingleValue = selectorSingleValue.toLocaleDateString();
            } else if (!selectorSingleValue) {
                formattedSingleValue = '';
            }
        }

        setValue('singleValue', formattedSingleValue);
    }, [selectorSingleValue, selectorDataType, setValue]);

    useEffect(() => {
        let formattedFromValue = selectorFromValue;

        if (selectorDataType === 'DATE') {
            if (selectorFromValue && selectorFromValue.format) {
                formattedFromValue = dayjs(selectorFromValue).format('MM/DD/YYYY');
            } else if (selectorFromValue instanceof Date) {
                formattedFromValue = selectorFromValue.toLocaleDateString();
            } else if (!selectorFromValue) {
                formattedFromValue = '';
            }
        }

        setValue('fromValue', formattedFromValue);
    }, [selectorFromValue, selectorDataType, setValue]);


    useEffect(() => {
        let formattedToValue = selectorToValue;

        if (selectorDataType === 'DATE') {
            if (selectorToValue && selectorToValue.format) {
                formattedToValue = dayjs(selectorToValue).format('MM/DD/YYYY');
            } else if (selectorToValue instanceof Date) {
                formattedToValue = selectorToValue.toLocaleDateString();
            } else if (!selectorToValue) {
                formattedToValue = '';
            }
        }

        setValue('toValue', formattedToValue);
    }, [selectorToValue, selectorDataType, setValue]);



    const handleCdpvfInfo = () => {
        setCdpvfInfoOpen(true);
    };

    const handleCloseCdpvfInfo = () => {
        setCdpvfInfoOpen(false);
    };

    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my contractDataPointValueFilter data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if((contractDataPointValueFilterDrawerMode==="Add") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
            addContractDataPointValueFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                    if (key === "previousFilter" ) {
                        return undefined;}
                    return value;
                })))
                .then(() => {
                    console.log("ContractDataPointValueFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                updateCdpvfMockValueAdd().then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                // dispatchData(changeContractDataPointValueFilter({
                //     cdpvfDrawerState: false, cdpvfDrawerContext: "none", cdpvfRebuildHierarchy: true }));
                dispatchData(changeContractDrilldownCDPVF({
                    cdpvfDrawerState: false, cdpvfDrawerContext: "none", cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true }));
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));

            })})}
        if((contractDataPointValueFilterDrawerMode==="Add") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
            addContractDataPointValueFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                    if (key === "parentFilter" || key === "previousFilter") {
                        return undefined;}
                    return value;
                })))
                .then(() => {
                    console.log("ContractDataPointValueFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).then(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("cdpvf hierarchy updated on cdp id " + {selectorCdpId} )
                updateCdpvfMockValueAdd().then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                dispatchData(changeContractDrilldownCDPVF({
                    cdpvfDrawerState: false,cdpvfDrawerContext: "none", cdpvfRebuildHierarchy: true , cdpvfGridRefresh: true }));
                // dispatchData(changeContractDataPointValueFilter({
                //     cdpvfDrawerState: false,cdpvfDrawerContext: "none", cdpvfRebuildHierarchy: true }));
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));

                })}) })}
        if((contractDataPointValueFilterDrawerMode==="Add") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            addContractDataPointValueFilter(
                JSON.parse(JSON.stringify(data, (key, value) => {
                    if (key === "parentFilter") {
                        return undefined;}
                    return value;
                })))
                .then(() => {
                    console.log("ContractDataPointValueFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).then(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("hierarchy updated")
                updateCdpvfMockValueAdd().then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                    dispatchData(changeContractDrilldownCDPVF({
                        cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true  }));

                })})})}
        if((contractDataPointValueFilterDrawerMode==="Add") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            addContractDataPointValueFilter(data)
                .then(() => {
                    console.log("ContractDataPointValueFilter added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                    // fetchContractDataPointValueFilters();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("hierarchy updated")
                updateCdpvfMockValueAdd().then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                // dispatchData(changeContractDataPointValueFilter({
                //     cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true }));
                dispatchData(changeContractDrilldownCDPVF({
                    cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true  }));
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
                })})})}
            if((contractDataPointValueFilterDrawerMode==="Edit") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
                console.log("This is the contractDataPointValueFilter Id I am going to edit")
                console.log(selectorContractDataPointValueFilterId)
            editContractDataPointValueFilter(selectorContractDataPointValueFilterId,                 JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "previousFilter" ) {
                    return undefined;}
                return value;
            })))
                .then(() => {
                    console.log("ContractDataPointValueFilter edited without previous")
                    console.log(JSON.parse(JSON.stringify(data, (key, value) => {
                        if (key === "previousFilter" ) {
                            return undefined;}
                        return value;
                    })))
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                    // fetchContractDataPointValueFilters();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("cdpvf hierarchy updated on cdp id ",selectorCdpId )
                updateCdpvfMockValueEdit(selectorContractDataPointValueFilterId).then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
                // dispatchData(changeContractDataPointValueFilter
                dispatchData(changeContractDrilldownCDPVF
                ({id: 0, contractDataPointId: null, contractDataPointValueId: null,
                    parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,
                    dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, mockValue: null, expressionIndicator: null,
                    mockExpression: null, mockExpressionTranslation: null,
                    createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
                    cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true }));

                }) }) })}
        if((contractDataPointValueFilterDrawerMode==="Edit") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId === '' ) || (data.previousFilterId === null ))){
            console.log("This is the contractDataPointValueFilter Id I am going to edit")
            console.log(selectorContractDataPointValueFilterId)
            editContractDataPointValueFilter(selectorContractDataPointValueFilterId,                 JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "parentFilter" || key === "previousFilter") {
                    return undefined;}
                return value;
            })))
                .then(() => {
                    console.log("ContractDataPointValueFilter edited without parent or previous, data below")
                    console.log(JSON.parse(JSON.stringify(data, (key, value) => {
                        if (key === "parentFilter" || key === "previousFilter") {
                            return undefined;}
                        return value;
                    })))
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("hierarchy updated")
                updateCdpvfMockValueEdit(selectorContractDataPointValueFilterId).then(() => {
                console.log("mock value updated")
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
                // dispatchData(changeContractDataPointValueFilter({
                    dispatchData(changeContractDrilldownCDPVF({
                    id: 0, contractDataPointId: null, contractDataPointValueId: null,
                    parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,
                    dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, mockValue: null, expressionIndicator: null,
                    mockExpression: null, mockExpressionTranslation: null,
                    createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
                    cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true  }));
                }) })  })}
        if((contractDataPointValueFilterDrawerMode==="Edit") && ((data.parentFilterId === '' ) || (data.parentFilterId === null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            console.log("This is the contractDataPointValueFilter Id I am going to edit")
            console.log(selectorContractDataPointValueFilterId)
            editContractDataPointValueFilter(selectorContractDataPointValueFilterId,
                JSON.parse(JSON.stringify(data, (key, value) => {
                if (key === "parentFilter") {
                    return undefined;}
                return value;
            })))
                .then(() => {
                    console.log("ContractDataPointValueFilter edited without parent")
                    console.log(                JSON.parse(JSON.stringify(data, (key, value) => {
                        if (key === "parentFilter") {
                            return undefined;}
                        return value;})))
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                    // fetchContractDataPointValueFilters();
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("hierarchy updated")
                updateCdpvfMockValueEdit(selectorContractDataPointValueFilterId).then(() => {
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
                // dispatchData(changeContractDataPointValueFilter({
                    dispatchData(changeContractDrilldownCDPVF({
                    id: 0, contractDataPointId: null, contractDataPointValueId: null,
                    parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,
                    dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, mockValue: null, expressionIndicator: null,
                    mockExpression: null, mockExpressionTranslation: null,
                    createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
                    cdpvfDrawerState: false,cdpvfDrawerContext: "none", cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true }));
                })}) })}
        if((contractDataPointValueFilterDrawerMode==="Edit") && ((data.parentFilterId !== '' ) && (data.parentFilterId !== null ))  && ((data.previousFilterId !== '' ) && (data.previousFilterId !== null ))){
            console.log("This is the contractDataPointValueFilter Id I am going to edit")
            console.log(selectorContractDataPointValueFilterId)
            console.log("This is my data")
            console.log(data)
            editContractDataPointValueFilter(selectorContractDataPointValueFilterId,data)
                .then(() => {
                    console.log("ContractDataPointValueFilter edited with both parent and previous sent")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                updateCdpvfHierarchy(selectorCdpId).then(() => {
                console.log("hierarchy updated")
                updateCdpvfMockValueEdit(selectorContractDataPointValueFilterId).then(() => {
                console.log("cdpvf mock value edited on cdpvf id ", selectorContractDataPointValueFilterId);
                setSubmitting(false);
                setShowContractDataPointValueFilterDrawer(false);
                dispatchData(changeContractDataPoint({cdpGridRefresh: true,}));
                dispatchData(changeContractDrilldownCDPVF({
                    // dispatchData(changeContractDataPointValueFilter({
                    id: 0, contractDataPointId: null, contractDataPointValueId: null,
                    parentFilterId: null, previousFilterId: null, ordinalNumber: null, recordLevel: null,
                    dataPointId: null, singleValue: null, fromValue: null, toValue: null,
                    status: null, hierarchy: null, mockValue: null, expressionIndicator: null,
                    mockExpression: null, mockExpressionTranslation: null,
                    createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
                    cdpvfDrawerState: false, cdpvfDrawerContext: "none",cdpvfRebuildHierarchy: true, cdpvfGridRefresh: true  }));
                })}) })}
    };

    // ****************** END CRUD ****************************

    // *********************** BEGIN DROPDOWNS **************************

    const selectorParentId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.parentFilterId);
    const selectorPreviousId = useSelector((state) => state.contractDrilldownSlcCDPVF.value.previousFilterId);
    // const selectorParentId = useSelector((state) => state.contractDataPointValueFilterSlc.value.parentFilterId);
    // const selectorPreviousId = useSelector((state) => state.contractDataPointValueFilterSlc.value.previousFilterId);
    const [parentDropdown, setParentDropdown] = useState([]);
    const [selectedParent, setSelectedParent] = useState(0);
    let parentFilter;
    const [previousDropdown, setPreviousDropdown] = useState([]);
    const [selectedOrigin, setSelectedOrigin] = useState(null);


    const fetchContractSectionFiltersForParent = () =>
        getCDPVFbyCDPid(selectorCdpId)

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );

                setParentDropdown(data);

            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchContractSectionFiltersForParent();
    }, []);


    const fetchContractSectionFiltersForPrevious = () =>
        getCDPVFbyCDPid(selectorCdpId)

            .then(data => {
                console.log(data);
                setPreviousDropdown(data.filter(data => data.parentFilterId ===  parentFilter));

            })
            .then(() => console.log("selectedParent"))
            .then(() => console.log({selectedParent}))
            .then(() => console.log("parentFilter"))
            .then(() => console.log({parentFilter}))
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})
            .then(() => {setShowPreviousMenu(false)}).then(() => {setShowPreviousMenu(true)})

    const handleParentChange = (parentEvent) => {
        parentFilter = parentEvent.target.value;
        setSelectedParent(parentEvent.target.value);
        console.log("This is for the selected Parent Filter");
        console.log(parentEvent.target.value)
        fetchContractSectionFiltersForPrevious()

    };
    const handlePreviousChange = (previousEvent) => {
        setSelectedOrigin(previousEvent.target.value);
        console.log("This is for the selected Previous Filter");
        console.log(previousEvent.target.value);
    };


    // ******************* BEGIN AUTOCOMPLETE *********************

    let initialDataPointValues = null;



    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);
    const [selectedDataPointValue, setSelectedDataPointValue] = useState(null);
    const [selectedDataPointRow, setSelectedDataPointRow] = useState(null);

    const [dataPointValues, setDataPointValues] = useState([]);
    let selDataType = null;
    let selDataPointRow = null;

    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log("my dp all upon screen load")
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);

    // const fetchDataPointValues = () =>
    //     getAllDataPointValues()

    //         .then(data => {
    //             console.log("my dpv all upon screen load")
    //             console.log(data);
    //             if((data.dataPointId === 0)){setDataPointValues(data.filter(data => data.dataPointId ===  null));}
    //             else{
    //                 setDataPointValues(data.filter(data => data.dataPointId ===  selectorDPid));}
    //             initialDataPointValues = data.filter(data => data.dataPointId ===  selectorDPid);
    //             console.log("my dpv filtered list upon screen load")
    //             console.log(data.filter(data => data.dataPointId ===  selectorDPid));
    //         })
    // useEffect(() => {
    //     fetchDataPointValues();
    // }, []);

    const handleDataPointChange = (dataPointEvent) => {
        setSelectedDataPoint(dataPointEvent ? dataPointEvent.id : 0);
        console.log("This is selected data point's data");
        console.log(dataPointEvent);
        // console.log("This is the selected Data Type");
        dispatchData(changeContractDrilldownCDPVF({dataPointId: dataPointEvent ? dataPointEvent.id : 0, dataType: dataPointEvent ?  dataPointEvent.dataType : ""
            ,
            singleValue: null, fromValue: null, toValue: null}));
        // console.log(dataPoints.filter((dataPoints) => dataPoints.id ===  dataPointEvent));
        // let filteredData = dataPoints.filter((dataPoints) => dataPoints.id ===  dataPointEvent.id);
        // let filteredDataType = filteredData.map(filteredData => filteredData.dataType);
        // let FilteredDataTypeToString = filteredDataType.toString();
        // console.log(filteredData.map(filteredData => filteredData.dataType.toString()));
        // setSelectedDataType(filteredData.map(filteredData => filteredData.dataType.toString()));
        // setSelectedDataPointRow(dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent));
        // selDataPointRow = dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent);
        // selDataType = selDataPointRow[1];


        // getAllDataPointValues()

        //     .then(data => {
        //         console.log("my dpv all")
        //         console.log(data);
        //         // setDataPointValues(data);
        //         setDataPointValues(data.filter(data => data.dataPointId ===  dataPointEvent));
        //         console.log("my dpv filtered list")
        //         console.log(data);
        //     })
    };

    const handleDataPointValueChange = (event2) => {
        setSelectedDataPointValue(event2);
        console.log("This is for the selected Data Point Value");
        console.log(event2);
    };

    // this sets the setValue to the dp id that is loaded when editing
    useEffect(() => {
        const existingValue = selectorDataPointId;
        setValue('dataPoint.id', existingValue ? existingValue : null);
    }, [selectorDataPointId, setValue]);

    //
    //
    // const handleDataPointChange = (dataPointEvent) => {
    //     setSelectedDataPoint(dataPointEvent.target.value);
    //     console.log("This is selected Value");
    //     console.log(dataPointEvent.target.value);
    //     console.log("This is the selected Data Type");
    //     console.log(dataPoints.filter((dataPoints) => dataPoints.id ===  dataPointEvent.target.value));
    //     let filteredData = dataPoints.filter((dataPoints) => dataPoints.id ===  dataPointEvent.target.value);
    //     let filteredDataType = filteredData.map(filteredData => filteredData.dataType);
    //     let FilteredDataTypeToString = filteredDataType.toString();
    //     console.log(filteredData.map(filteredData => filteredData.dataType.toString()));
    //     setSelectedDataType(filteredData.map(filteredData => filteredData.dataType.toString()));
    //     setSelectedDataPointRow(dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent.target.value));
    //     selDataPointRow = dataPoints.filter(dataPoints => dataPoints.id ===  dataPointEvent.target.value);
    //     // selDataType = selDataPointRow[1];
    //     getAllDataPointValues()

    //         .then(data => {
    //             console.log("my dpv all")
    //             console.log(data);
    //             // setDataPointValues(data);
    //             setDataPointValues(data.filter(data => data.dataPointId ===  dataPointEvent.target.value));
    //             console.log("my dpv filtered list")
    //             console.log(data);
    //         })};
    //
    // const handleDataPointValueChange = (event2) => {
    //     setSelectedDataPointValue(event2.target.value);
    //     console.log("This is for the selected Data Point Value");
    //     console.log(event2.target.value);
    // };
    //


    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function openContractDataPointValueFilterDrawer() {
        setShowContractDataPointValueFilterDrawer(true);
    };

    function closeContractDataPointValueFilterDrawer() {
        dispatchData(changeContractDrilldownCDPVF({cdpvfDrawerContext: "none",
            cdpvfDrawerState: false}));
        // dispatchData(changeContractDataPointValueFilter({cdpvfDrawerContext: "none",
        //     cdpvfDrawerState: false}));
        dispatchData(changeContractDataPoint({cdpGridRefresh: true}));
    };

    // ****************** END MISC ****************************


    // ****************** BEGIN FORM ****************************

    function contractDataPointValueFilterForm(selectorContractGridAPI){
        return(
            <div>
                <CdpvfInfoDialogue
                    open={cdpvfInfoOpen}
                    onClose={handleCloseCdpvfInfo}
                    selectorContractGridAPI={selectorContractGridAPI}
                />
                <form
                    onSubmit={handleSubmit((data) => onSubmit(data))}
                >
                    <Box
                        sx={{width: 800, height: 800, pl: 5}}
                        role="presentation"
                    >
                        <h1  style={{cursor: 'pointer' }} onClick={() => handleCdpvfInfo()}>Contract Data Point Value Filter
                            Form</h1>
                        <Tooltip enterDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"Contract Data Point Value Filer ID: " + selectorContractDataPointValueFilterId +
                        "\nContract Data Point ID: " + selectorCdpId +
                        "\nData Type: " + selectedDataType +
                        "\nData Point Value Id: " + selectorDPVid
                    }</span>}>
                            <h4     style={{cursor: 'pointer' }} onClick={() => closeContractDataPointValueFilterDrawer()}
                            >{contractDataPointValueFilterDrawerMode} Mode</h4>
                        </Tooltip>

                        <Input style={{visibility: "hidden"}}
                               {...register('id', {required: false})}
                               id="id" name="id" label="id" aria-describedby="id_entry"
                            // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.id)}
                               defaultValue={useSelector((state) => state.contractDrilldownSlcCDPVF.value.id)}
                        />
                        <Input style={{visibility: "hidden"}}
                               {...register('contractDataPoint.id', {required: true})}
                               id="contractDataPoint.id" name="contractDataPoint.id" label="contractDataPoint.id"
                               aria-describedby="contractDataPoint.id_entry"
                            // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.contractDataPointId)}
                               defaultValue={useSelector((state) => state.contractDrilldownSlcCDPVF.value.contractDataPointId)}
                        />
                        <br/>
                        <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                            <InputLabel htmlFor="parentFilterId">Parent Filter</InputLabel>
                            <Select
                                {...register('parentFilterId', {required: false})}
                                labelId="demo-simple-select-filled-parent"
                                id="parentFilterId"
                                // value={selectedParent}
                                label="Parent Filter"
                                onChange={handleParentChange}
                                defaultValue={selectorParentId}
                            >
                                {parentDropdown.map((parentItem) =>
                                    <MenuItem
                                        value={parentItem.id}>{parentItem.id} {parentItem.dataPointName} {parentItem.mockValue} {parentItem.fromValue} {parentItem.toValue}</MenuItem>
                                )}
                            </Select>
                            <FormHelperText id="value_helper">select the parent section this will go
                                under</FormHelperText>
                        </FormControl>

                        <br/>
                        {showPreviousMenu &&
                            <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                                <InputLabel htmlFor="previousFilterId">Previous Filter</InputLabel>
                                <Select
                                    // freeSolo
                                    {...register('previousFilterId', {required: false})}
                                    labelId="demo-simple-select-filled-label2"
                                    id="previousFilterId"
                                    label="Previous Filter"
                                    onChange={handlePreviousChange}
                                    defaultValue={selectorPreviousId}

                                >
                                    {previousDropdown.map((previousItem) =>
                                        <MenuItem value={previousItem.id}
                                        >{previousItem.id} {previousItem.dataPointName} {previousItem.mockValue} {previousItem.fromValue} {previousItem.toValue}</MenuItem>
                                    )}
                                </Select>
                                <FormHelperText id="origin_helper">select the filter this will go after within the
                                    parent</FormHelperText>
                            </FormControl>}
                        <br/>
                        <br/>
                        <br/>
                        {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>*/}
                        {/*    <InputLabel htmlFor="dataPoint.id">Data Point</InputLabel>*/}
                        {/*    <Select*/}

                        {/*        {...register('dataPoint.id', { required: true })}*/}
                        {/*        labelId="dataPoint.id"*/}
                        {/*        id="dataPoint.id"*/}
                        {/*        // value={selectedValue}*/}
                        {/*        label="dataPoint.id"*/}
                        {/*        onChange={handleDataPointChange}*/}
                        {/*        // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.dataPointId)}*/}
                        {/*        defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.dataPointId)}*/}
                        {/*    >*/}
                        {/*        {dataPoints.map((DataPointItem) =>*/}
                        {/*            <MenuItem value={DataPointItem.id}>{DataPointItem.name}</MenuItem>*/}
                        {/*        )}*/}
                        {/*    </Select>*/}
                        {/*    <FormHelperText id="contractLevel_helper">select the Data Point</FormHelperText>*/}
                        {/*</FormControl>*/}
                        <Autocomplete
                            disablePortal
                            disableCloseOnBlur
                            ListboxProps={{
                                style: {
                                    maxHeight: 400,  // <-- make the listbox longer
                                },
                                onClick: (event) => {
                                    event.stopPropagation();
                                }
                            }}

                            labelId="dataPoint.id"
                            id="dataPointId"
                            options={dataPoints}
                            // getOptionLabel={(option) => option.name}
                            // getOptionLabel={(option) => option && option.name ? option.name : ""}
                            getOptionLabel={(option) => {
                                if (!option) return "";
                                if (typeof option === 'number' || typeof option === 'string') {
                                    const found = dataPoints.find(dp => dp.id === parseInt(option));
                                    return found && found.name ? found.name : "";
                                }
                                return option && option.name ? option.name : "";
                            }}
                            filterOptions={(options, state) => {
                                return options.filter(option => {
                                    const name = option && option.name ? option.name : "";
                                    return name.toLowerCase().includes(state.inputValue.toLowerCase());
                                });
                            }}
                            isOptionEqualToValue={(option, value) => option && value ? option.id === value.id : option === value}
                            // isOptionEqualToValue={(option, value) => option && value ? option.id === '999999' : option === value}
                            // isOptionEqualToValue={() => false}
                            // isOptionEqualToValue={(option, value) => option.id === value.id}
                            // isOptionEqualToValue={(option, value) =>
                            //     option && value ? option.id === value.id : option === value}
                            // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}
                            // value={dataPoints.find(dp => dp.id === parseInt(selectorContractDataPointId))}
                            // value={selectorDataPointId || null}
                            value={dataPoints.find(dp => dp.id === parseInt(selectorDataPointId)) || null}
                            onChange={(event, newValue) => {
                                setSelectedDataPoint(newValue);
                                setValue('dataPoint.id', newValue ? newValue.id : null, {shouldValidate: true});
                                console.log("onChange triggered in Data Point dropddown");
                                handleDataPointChange(newValue ? newValue : null);
                            }}
                            onInputChange={(event, newInputValue, reason) => {
                                console.log("onInputChange triggered", newInputValue, reason);
                            }}
                            onHighlightChange={(event, option, reason) => {
                                console.log("onHighlightChange triggered", option, reason);
                            }}
                            sx={{width: 600}}
                            renderInput={(params) => <TextField {...params} label="Data Point" variant="standard"/>}
                            // ListboxComponent={ListboxComponent}
                        />
                        <FormHelperText id="DataPoint_helper">select the Data Point</FormHelperText>
                        <br/>
                        <br/>
                        <br/>


                        {/*{*/}
                        {/*    (*/}
                        {/*        selectedDataType.toString() === 'CODE' ||*/}
                        {/*        selectedDataType.toString() === 'YES_NO' ||*/}
                        {/*        selectedDataType.toString() === 'REFERENCE') &&*/}
                        {/*    <div>*/}
                        {/*        <FormControl variant="standard"*/}
                        {/*            // sx={{ m: 1, minWidth: 120 }}*/}
                        {/*                     sx={{  m: 1,width: 300 }}*/}
                        {/*        >*/}
                        {/*            <InputLabel htmlFor="singleValue">Value</InputLabel>*/}

                        {/*            <Select*/}
                        {/*                {...register('singleValue', { required: false })}*/}
                        {/*                labelId="singleValue"*/}
                        {/*                id="singleValue"*/}
                        {/*                // value={selectedDataPointValue}*/}
                        {/*                // defaultValue = {selectedDataPointId}*/}
                        {/*                label="singleValue"*/}
                        {/*                // onChange={(ev) => setItems(ev.target.value)}*/}
                        {/*                onChange={handleDataPointValueChange}*/}
                        {/*                // defaultValue=        {selectorDPVid}*/}
                        {/*                defaultValue=        {selectorSingleValue}*/}
                        {/*            >*/}
                        {/*                /!*<MenuItem value="">*!/*/}
                        {/*                /!*    <em>None</em>*!/*/}
                        {/*                /!*</MenuItem>*!/*/}
                        {/*                {dataPointValues.map((DataPointValueItem) =>*/}
                        {/*                    <MenuItem value={DataPointValueItem.id}>{DataPointValueItem.name}</MenuItem>*/}
                        {/*                )}*/}
                        {/*            </Select>*/}
                        {/*            /!*<FormHelperText id="Value_helper">blank if just the data point being there is enough</FormHelperText>*!/*/}
                        {/*        </FormControl>*/}
                        {/*        <br/>*/}
                        {/*        <br/>*/}
                        {/*        <Button*/}
                        {/*            type= "submit"*/}
                        {/*        >Submit</Button>*/}
                        {/*        <Button onClick={() => closeContractDataPointValueFilterDrawer()}>Cancel</Button>*/}
                        {/*    </div>*/}
                        {/*}*/}

                        {/*{*/}
                        {/*    (selectedDataType.toString() !== 'CODE' &&*/}
                        {/*        selectedDataType.toString() !== 'YES_NO' &&*/}
                        {/*        selectedDataType.toString() !== 'REFERENCE' &&*/}
                        {/*        selectedDataType.toString() !== '' &&*/}
                        {/*        selectedDataType.toString() !== null*/}
                        {/*    ) &&*/}
                        {/*    <div>*/}
                        {/*        <FormHelperText id="Value_helper">leave this section blank if just the data point being there is enough</FormHelperText>*/}
                        {/*        /!*<br/>*!/*/}
                        {/*        <FormControl*/}
                        {/*            // fullWidth*/}
                        {/*            sx={{ width: 200 }}*/}
                        {/*        >*/}
                        {/*            <InputLabel  htmlFor="singleValue">Value</InputLabel>*/}
                        {/*            <Input*/}
                        {/*                {...register('singleValue', { required: false })}*/}
                        {/*                id="singleValue" name="singleValue"  label="Single Value" aria-describedby="singleValue_entry"*/}
                        {/*                defaultValue=        {selectorSingleValue}*/}
                        {/*            />*/}
                        {/*            <FormHelperText id="SingleValue_helper">exact match</FormHelperText>*/}
                        {/*        </FormControl>*/}

                        {/*        <br/>*/}
                        {/*        <FormHelperText id="Value_helper">- or -</FormHelperText>*/}


                        {/*<br/>*/}
                        {/*<InputLabel  htmlFor="fromValue">From Value</InputLabel>*/}
                        {/*<Input*/}
                        {/*    {...register('fromValue', { required: false })}*/}
                        {/*    id="fromValue" name="fromValue"  label="From Value" aria-describedby="fromValue_entry"*/}
                        {/*    defaultValue=        {selectorFromValue}*/}
                        {/*/>*/}
                        {/*<FormHelperText id="fromValue_helper">enter a from value</FormHelperText>*/}
                        {/*<br/>*/}
                        {/*<InputLabel  htmlFor="toValue">To Value</InputLabel>*/}
                        {/*<Input*/}
                        {/*    {...register('toValue', { required: false })}*/}
                        {/*    id="toValue" name="toValue"  label="To Value" aria-describedby="toValue_entry"*/}
                        {/*    defaultValue=        {selectorToValue}*/}
                        {/*/>*/}
                        {/*<FormHelperText id="toValue_helper">enter a to value</FormHelperText>*/}
                        {/*<br/>*/}

                        {/*/!*<Button*!/*/}
                        {/*/!*    type= "submit"*!/*/}
                        {/*/!*>Submit</Button>*!/*/}
                        {/*/!*<Button onClick={() => closeContractDataPointValueFilterDrawer()}>Cancel</Button>*!/*/}
                        {/*    </div>}*/}
                        {/*<HiddenFields />*/}

                    {/*<br/>*/}
                    {/*<br/>*/}
                    {/*<br/>*/}
                    {!!selectorDataType &&
                        // {(selectorDataType !== null && selectorDataType !== undefined && selectorDataType !== "") &&
                        <div>
                            <FormHelperText id="Value_helper">leave this section blank if just the data point is
                                enough for matching</FormHelperText>
                            <br/>
                            <DynamicCdpvValueField
                                selectorDataPointId={selectorDataPointId}
                                selectorValue={selectorSingleValue}
                                selectorDataType={selectorDataType}
                                selectorContext={"ContractDataPointValueFilterSingleValue"}
                                selectorLabel={"Exact Value"}
                            />
                            {(selectorDataType !== 'CODE' &&
                                    selectorDataType !== 'YES_NO' &&
                                    selectorDataType !== 'REFERENCE') &&
                                <div>
                                    <br/>
                                    <br/>
                                    <FormHelperText id="Value_helper">- or -</FormHelperText>

                                    <br/>
                                    <Stack direction="row" spacing={4}>
                                        <DynamicCdpvValueField
                                            selectorDataPointId={selectorDataPointId}
                                            selectorValue={selectorFromValue}
                                            selectorDataType={selectorDataType}
                                            selectorContext={"ContractDataPointValueFilterFromValue"}
                                            selectorLabel={"From Value"}
                                        />
                                        <DynamicCdpvValueField
                                            selectorDataPointId={selectorDataPointId}
                                            selectorValue={selectorToValue}
                                            selectorDataType={selectorDataType}
                                            selectorContext={"ContractDataPointValueFilterToValue"}
                                            selectorLabel={"To Value"}
                                        />
                                    </Stack>
                                </div>}
                            <br/>
                            <br/>
                            <Button
                                type="submit"
                            >Submit</Button>
                            <Button onClick={() => closeContractDataPointValueFilterDrawer()}>Cancel</Button>
                        </div>}
                    </Box>
                    <HiddenFields/>
                </form>
            </div>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.status)}
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('hierarchy', { required: false })}
                       id="hierarchy" name="hierarchy"  label="hierarchy" aria-describedby="hierarchy_entry"
                       // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.hierarchy)}
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.hierarchy)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.createdBy)}
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.createdBy)}
                />

                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.lastModifiedBy)}
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.lastModifiedBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('contractDataPointValueId', { required: false })}
                       id="contractDataPointValueId" name="contractDataPointValueId"  label="contractDataPointValueId" aria-describedby="contractDataPointValueId_entry"
                       // defaultValue=        {useSelector((state) => state.contractDataPointValueFilterSlc.value.contractDataPointValueId)}
                       defaultValue=        {useSelector((state) => state.contractDrilldownSlcCDPVF.value.contractDataPointValueId)}
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                // open={useSelector((state) => state.contractDataPointValueFilterSlc.value.cdpvfDrawerState) }
                open={useSelector((state) => state.contractDrilldownSlcCDPVF.value.cdpvfDrawerState) }
                initialState={{open: false}}
                onClose={closeContractDataPointValueFilterDrawer}
            >
                {contractDataPointValueFilterForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
